import { useQuery } from '@tanstack/react-query';
import { edupassClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';

interface UseSubscriptionLimitResponse {
  canSubscribe: boolean;
  activeSubscriptionsCount: number;
  periodInDays: number;
  subscriptionLimit: number;
}

export const useSubscriptionLimit = () => {
  const response = useQuery<{ data: UseSubscriptionLimitResponse }>({
    queryKey: [clientKeys.useCheckSubscriptionLimit],
    queryFn: async () =>
      await edupassClient.get(`/catalog/course/check-subscription-limit`),
  });
  const canSubscribe = response?.data?.data?.canSubscribe;
  const limit = response?.data?.data?.subscriptionLimit;

  return { canSubscribe, limit, ...response };
};
